import { useRef, useState } from 'react';
import { LicenseManager, type PortfolioLicense } from './intake/LicenseManager';
import { LicenseManagementPro } from './intake/LicenseManagementPro';

/**
 * Firm › Licenses (RESTORE_PLAN R3.3): the home of the two kept license screens.
 * The dashboard (LicenseManager: portfolio value, what expires in 30 days,
 * urgent renewals, CSV export) sits above the manager (LicenseManagementPro:
 * the portfolio, renewal pipeline and analytics on `/license/*`), and is fed
 * from the manager's own load so the two always agree. Each client's apps and
 * license counts live on its Company Settings (CompanyAppsCard).
 */
export function FirmLicenses({ accessToken, firmId, currentUser }: { accessToken: string; firmId: string; currentUser: any }) {
  // null until the manager has loaded a portfolio: without the add-on there is none, and only the manager's offer shows
  const [portfolio, setPortfolio] = useState<PortfolioLicense[] | null>(null);
  const managerRef = useRef<HTMLDivElement>(null);

  return (
    <div className="space-y-6">
      {portfolio && (
        <LicenseManager
          accessToken={accessToken}
          firmId={firmId}
          currentUser={currentUser}
          viewMode="dashboard"
          licenses={portfolio}
          onViewAll={() => managerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
        />
      )}
      <div ref={managerRef}>
        <LicenseManagementPro
          accessToken={accessToken}
          firmId={firmId}
          currentUser={currentUser}
          onLicensesChanged={(licenses) => setPortfolio(licenses as PortfolioLicense[])}
        />
      </div>
    </div>
  );
}
